module.exports = __webpack_public_path__ + "img/p-one-step-15.00270025.png";